module.exports = __webpack_public_path__ + "static/imageOne@2x-a8f24e3a82cabb5be808e666504baaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/imageOne@2x.png
// module id = 2605
// module chunks = 168707334958949